import { getCurrentGrabTodoList, setOwner } from '@/api/todo';

type IGrabTodoInfo = ITodo.IResponse.IGrabTodoInfo;
export default class GrabTodoList {
  public list: IGrabTodoInfo[] = [];
  public async requestGrabTodoList() {
    try {
      const res = await getCurrentGrabTodoList();
      this.list = res.data;
      return Promise.resolve(res);
    } catch (error) {
      return Promise.reject(error);
    }
  }
  public async requestAcceptTodo(params: {todoId: string, comment: string, owner: string, ownerName: string}) {
    try {
      const {todoId, comment, owner, ownerName} = params;
      const res = await setOwner({
        todoId,
        staffId: null,
        comment,
        isAgree: false,
      });
      this.updateTodo({id: todoId, grabComment: comment, owner, ownerName});
      return Promise.resolve(res);
    } catch (error) {
      return Promise.reject(error);
    }
  }
  public updateTodo(newTodo: Partial<IGrabTodoInfo>) {
    const index = this.list.findIndex((todo) => todo.id === newTodo.id);
    if (index >= 0) {
      this.list[index] = {...this.list[index], ...newTodo};
    }
  }
}
export const grabTodoListInstance = new GrabTodoList();
